import React, { useEffect, useState } from "react";
import axiosConfig from "../../Service/axiosConfig";
import { MdDeleteOutline } from "react-icons/md";
import DataTable from "react-data-table-component";
import { DeletePopupModal, PopupModal } from "../../Components";
import AlertDeletePopupModal from "../../Components/PopupModal/AlertDeletePopupModal";
import "../../Pages/master_categories.css";
import {
  MdKeyboardArrowUp,
  MdKeyboardArrowDown,
  MdDelete,
} from "react-icons/md";
import { FiSave } from "react-icons/fi";
import { FileManager } from "../../Components/FileManager";
import Select from "react-select";
import { FaHandHoldingHeart } from "react-icons/fa";
import tableCustomStyles from "../PopupModal/tableCustomStyles";
const VerticalBannerSection = ({
  id,
  selectedhomepageId,
  vertical_bannerSecId,
  is_suspended,
  getTemplate
}) => {
  const [AlertDeletePopupType, SetAlertDeletePopupType] = useState("");
  const [deletePopupType, setDeletepopupType] = useState("");
  const [loading, setLoading] = useState(false);
  const [RowId, SetRowId] = useState();
  const [RowPerPage, setRowPerPage] = useState(20);
  const [selectedRows, setSelectedRows] = useState([]);
  const [Error, SetError] = useState();
  const [popupType, setpopupType] = useState("");
  const [sortedBanners, setSortedBanners] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [Data, SetData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [modalShow, setModalShow] = useState(false);
  const [Message, SetMessage] = useState("");
  const [verticalbannerOptions, setVerticalbannerOptions] = useState([]);
  const [selectedVertical, setSelectedVertical] = useState([]);
  const [formData, setFormData] = useState({});

  const fetchVerticalBanners = async () => {
    setLoading(true);
    try {
      const response = await axiosConfig.get(
        `catlog/banners/?banner_type=vertical_banner&page_size=50&is_suspended=false`
      );
      console.log(response, "ghhh");

      setVerticalbannerOptions(
        response.data.results.map((vertical) => ({
          value: vertical.id,
          label: vertical.name,
        }))
      );
    } catch (error) {
      console.error("Error fetching vertical banners:", error);
      setVerticalbannerOptions([]);
    }
  };

  useEffect(() => {
    fetchVerticalBanners();
  }, []);
  const GetData = async () => {
    setLoading(true);
    try {
      const response = await axiosConfig.get(
        `/cms/get_homepagedesign/?section_id=${vertical_bannerSecId}`
      );
      const flattenedVertical = response.data.results.flatMap((section) =>
        section.vertical_banners.map((vertical) => ({
          ...vertical,
          section_id: section.id,
          section_title: section.title,
        }))
      );
      SetData(flattenedVertical);
      setLoading(false);
      setTotalRows(flattenedVertical.length);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    GetData();
  }, [vertical_bannerSecId]);

  console.log(Data, "kljm");
  const handleVerticalBannerChange = (selectedOptions) => {
    setSelectedVertical(selectedOptions);
  };
  const handleImageChange = (files) => {
    const file = files[0].image;
    const file_key = files[0].id;
    setSelectedImage(file);
    setFormData({ ...formData, ["image"]: file_key });
  };

  const handleSort = (column, direction, newOrder) => {
    setSortedBanners(newOrder);
    axiosConfig
      .get(
        `catlog/banners/?banner_type=vertical_banner?ordering=${direction === "asc" ? column.selector : -column.selector
        }`
      )
      .then((res) => {
        SetData(res.data.results);
      })
      .catch((error) => {
        console.log(error);
      });
    setCurrentPage(1);
  };
  const handleRowSelected = ({ selectedRows }) => {
    setSelectedRows(selectedRows);
  };

  const handleSaveSelected = async () => {
    if (selectedVertical.length === 0) {
      return;
    }
    const selectedIds = selectedVertical.map((vertical) =>
      parseInt(vertical.value, 10)
    );
    try {
      const headers = {
        "Content-Type": "application/json",
      };
      if (vertical_bannerSecId) {
        // Update existing template
        await axiosConfig.post(
          `/cms/homepage_template/${vertical_bannerSecId}/add_items/`,
          {
            item_type: "vertical_banners",
            item_ids: selectedIds,
          },
          { headers }
        );
        SetMessage("Vertical Banner Template updated successfully");
        setpopupType("success");
      } else {
        // Create a new template
        await axiosConfig.post(
          "/cms/homepage_template/",
          {
            home_page: selectedhomepageId,
            title: "Vertical Banners",
            vertical_banners: selectedIds,
            sort: id,
          },
          { headers }
        );
        SetMessage("Vertical Banner Template created successfully");
        setpopupType("success");
      }
      await GetData();
      await getTemplate()
    } catch (error) {
      SetError("Error saving template");
      setpopupType("error");
      console.error("Error saving vertical template:", error);
    }
  };

  const columns = [
    {
      name: "S.No",
      selector: "id",
      cell: (row, i) => (currentPage - 1) * RowPerPage + i + 1,
      sortable: true,
    },
    {
      name: "Name",
      selector: "name",
      cell: (row) => row.name,
      sortable: true,
    },
    {
      name: "Image",
      selector: "image__image",
      cell: (row) => (
        <img src={row.image__image} alt={row.name} style={{ width: "100px" }} />
      ),
      sortable: false,
    },
    {
      name: "Slug",
      selector: "slug",
      cell: (row) => row.cat_slug || row.sub_slug,
      sortable: true,
    },
    {
      name: "Section Title",
      selector: "section_title",
      cell: (row) => row.section_title,
      sortable: true,
    },
    {
      name: "Section ID",
      selector: "section_id",
      cell: (row) => row.section_id,
      sortable: true,
    },
    {
      name: "ACTIONS",
      width: "150px",
      selector: (row) => {
        const DeleteAlert = () => {
          SetRowId(row.id);
          SetAlertDeletePopupType("success");
        };
        const CancelAlerrt = () => {
          SetAlertDeletePopupType("error");
        };

        const HandleDelete = async (id) => {
          try {
            if (vertical_bannerSecId) {
              await axiosConfig.post(
                `/cms/homepage_template/${vertical_bannerSecId}/remove_items/`,
                {
                  item_type: "vertical_banners",
                  item_ids: id,
                }
              );
            }

            SetAlertDeletePopupType("error");
            setDeletepopupType("success");
            await GetData();
            setTimeout(() => {
              getTemplate()
            }, 200)
            // await getTemplate()
          } catch (error) {
            setDeletepopupType("error");
            SetAlertDeletePopupType("error");
            console.error("Error deleting banner:", error);
          }
        };

        return (
          <>
            {!row.is_suspended ? (
              <div className="row">
                <div className="table-actions">
                  <button className="action-btn delete-btn" onClick={DeleteAlert}>
                    <MdDeleteOutline /> Delete
                  </button>
                </div>
              </div>
            ) : null}
            {AlertDeletePopupType === "success" && (
              <AlertDeletePopupModal
                AlertDeletePopupType={AlertDeletePopupType}
                HandleDelete={HandleDelete}
                CancelAlerrt={CancelAlerrt}
                row={RowId}
              />
            )}
          </>
        );
      },
    },
  ];
  const SectionDelete = async () => {
    try {
      await axiosConfig.delete(
        `/cms/homepage_template/${vertical_bannerSecId}/`
      );
      SetMessage("vertical banner template deleted successfully");
      setpopupType("success");
      GetData();
    } catch (error) {
      SetError("Error deleting vertical banner template");
      setpopupType("error");
      console.error(error);
    }
  };
  const handleReviveSection = async () => {
    try {
      const response = await axiosConfig.post(
        `/cms/homepage_template/${vertical_bannerSecId}/revive/`
      );
      setpopupType("success");
      SetMessage("vertical banner section revived successfully");
      GetData();
    } catch (error) {
      SetError("Error while reviving vertical banner section");
      setpopupType("error");
      console.error("Revival error:", error);
    }
  };

  return (
    <>
      <div className="child-sidenav">
        <div className="childnav-content">
          <div className="text-block-end border-remove">
            <div className="text-block-border">
              <h5 className="dashboard-subtitle">Vertical Banner Section</h5>

              <div className="d-flex gap-4">
                {!is_suspended ? (
                  <>
                    <MdKeyboardArrowUp />
                    <MdKeyboardArrowDown />
                    <FiSave
                      size={24}
                      onClick={handleSaveSelected}
                      style={{ cursor: "pointer" }}
                    />
                    <MdDelete
                      style={{ cursor: "pointer" }}
                      size={24}
                      onClick={SectionDelete}
                    />
                  </>
                ) : (
                  <FaHandHoldingHeart
                    size={24}
                    onClick={handleReviveSection}
                    style={{ cursor: "pointer", color: "green" }}
                  />
                )}
              </div>
            </div>

            <div className="col-md-4 sub-filter mt-3">
              <Select
                options={verticalbannerOptions}
                isMulti={true}
                placeholder="Select Vertical Banners"
                onChange={handleVerticalBannerChange}
                value={selectedVertical}
              />
            </div>

            <div className="p-2">
              <div className="table-responsive">
                <DataTable
                  columns={columns}
                  data={Data}
                  pagination
                  paginationTotalRows={totalRows}
                  paginationPerPage={RowPerPage}
                  onSelectedRowsChange={handleRowSelected}
                  draggableColumns
                  paginationDefaultPage={currentPage}
                  customStyles={tableCustomStyles}
                  onChangePage={(page) => setCurrentPage(page)}
                  paginationPerPageOptions={[10, 20, 25, 30, 40, 50]}
                  paginationRowsPerPageOptions={[10, 20, 25, 30, 40, 50]}
                  onChangeRowsPerPage={(RowsPerPageChange) =>
                    setRowPerPage(RowsPerPageChange)
                  }
                  onSort={handleSort}
                  progressPending={loading}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {popupType && (
        <PopupModal
          popupType={popupType}
          setpopupType={setpopupType}
          Message={Message}
          error={Error}
        />
      )}
      {deletePopupType && (
        <DeletePopupModal
          setDeletepopupType={setDeletepopupType}
          deletePopupType={deletePopupType}
        />
      )}
      {modalShow && (
        <FileManager
          modalShow={modalShow}
          setModalShow={setModalShow}
          handleFile={handleImageChange}
          ismultiple={false}
          value="image_key"
        />
      )}
    </>
  );
};

export { VerticalBannerSection };
